import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { DictionaryDirpAreaAutocomplete } from './../../models';

export function useDirpAreas() {
  return useAutocompleteSource<DictionaryDirpAreaAutocomplete>({
    url: `${EvidenceAPI.DICTIONARY_DIRP_AREAS}/autocomplete`,
  });
}
